import React from 'react';
import classNames from 'classnames';
import type { User } from '../types';
import './ImpersonationBanner.scss';

interface ImpersonationBannerProps {
  readonly impersonatedUser: User;
  readonly onEndImpersonation: () => void;
  readonly isLoading?: boolean;
  readonly className?: string;
}

/**
 * Prominent banner that displays when impersonating a user
 * Following ben-app component patterns and BEM-like naming
 */
export default function AdminImpersonationBanner({
  impersonatedUser,
  onEndImpersonation,
  isLoading = false,
  className,
}: ImpersonationBannerProps) {
  return (
    <div className={classNames('admin-impersonation-banner', className)}>
      <div className="admin-impersonation-banner__content">
        <div className="admin-impersonation-banner__info">
          <span className="admin-impersonation-banner__icon">👤</span>
          <span className="admin-impersonation-banner__text">
            <strong>Impersonating:</strong>{' '}
            <span className="admin-impersonation-banner__user">
              {impersonatedUser.firstName} {impersonatedUser.lastName} (
              {impersonatedUser.email})
            </span>
          </span>
        </div>
        <button
          type="button"
          className="admin-impersonation-banner__end-button"
          onClick={onEndImpersonation}
          disabled={isLoading}
        >
          {isLoading ? 'Ending...' : 'End Impersonation'}
        </button>
      </div>
    </div>
  );
}
